var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82064 6.84896C7.78714 6.84896 8.57064 7.63246 8.57064 8.59896V15.3338H15.3055C16.272 15.3338 17.0555 16.1173 17.0555 17.0838C17.0555 18.0503 16.272 18.8338 15.3055 18.8338H6.82064C5.85414 18.8338 5.07064 18.0503 5.07064 17.0838V8.59896C5.07064 7.63246 5.85414 6.84896 6.82064 6.84896Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3074 16.2051C10.6421 8.71355 18.747 3.66711 28.0326 3.66711C41.8857 3.66711 53.1159 14.8973 53.1159 28.7505C53.1159 42.6036 41.8857 53.8338 28.0326 53.8338C14.1794 53.8338 2.94922 42.6036 2.94922 28.7505C2.94922 27.784 3.73272 27.0005 4.69922 27.0005C5.66572 27.0005 6.44922 27.784 6.44922 28.7505C6.44922 40.6706 16.1124 50.3338 28.0326 50.3338C39.9527 50.3338 49.6159 40.6706 49.6159 28.7505C49.6159 16.8303 39.9527 7.16711 28.0326 7.16711C20.0468 7.16711 13.0716 11.5033 9.33684 17.958C8.8528 18.7945 7.78225 19.0803 6.94569 18.5963C6.10913 18.1122 5.82336 17.0417 6.3074 16.2051Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0387 13.0004C29.0052 13.0005 29.7886 13.7841 29.7885 14.7506L29.7872 28.0359L39.1672 37.4159C39.8506 38.0993 39.8506 39.2074 39.1672 39.8908C38.4838 40.5742 37.3757 40.5742 36.6923 39.8908L26.7997 29.9982C26.4714 29.6699 26.2871 29.2247 26.2871 28.7605L26.2885 14.7503C26.2886 13.7838 27.0722 13.0004 28.0387 13.0004Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.226161cf.svg";
export { ForwardRef as ReactComponent };